import * as React from 'react';
export const comericaSvg = React.forwardRef(function comericaSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0A62A6',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M18 12.83a4.66 4.66 0 0 1 4.48-2.9c3.06 0 5.2 2.12 5.2 5.21 0 3.12-1.98 5.93-5.2 5.9-2.98.03-5.03-2.52-5.01-5.4v-.1c-.06-5-2.17-6.64-5.1-6.79C8.7 8.57 7 11.92 7.01 16.22 7 19.54 8.7 23.13 12.5 23.14c2.28 0 3.56-.62 5.15-2.24l.38.49a7.37 7.37 0 0 1-5.72 2.83c-4.54-.02-8-3-8-8.2 0-4.74 3.27-8.24 7.95-8.24 3.17 0 4.34 1.96 5.1.05h.48l.16 5zm7.46 3.73c.18-2.15-.21-5.7-2.84-5.95-1.72-.13-2.74 1.43-2.94 3.51-.3 3.32.6 6.05 2.8 6.24 1.8.16 2.8-1.75 2.98-3.8z',
      }),
    ),
  );
});
comericaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var comerica = {
  category: 'brand',
  colorable: false,
  name: 'comerica',
  svg: comericaSvg,
};
